// extracted by mini-css-extract-plugin
export default {"postsBlock":"MyPosts_postsBlock__lB-pf"};